import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/home';

const footerLinks = {
  platform: {
    title: '平台',
    links: [
      { label: '关于91short', href: '/about' },
      { label: '创作者中心', href: '/about' },
      { label: '帮助中心', href: '/about' },
      { label: '用户协议', href: '/about' },
    ],
  },
  support: {
    title: '支持',
    links: [
      { label: '意见反馈', href: '/about' },
      { label: '内容举报', href: '/about' },
      { label: '安全中心', href: '/about' },
      { label: '社区规范', href: '/about' },
    ],
  },
  business: {
    title: '商务合作',
    links: [
      { label: '广告投放', href: '/about' },
      { label: '品牌合作', href: '/about' },
      { label: '创作者招募', href: '/about' },
      { label: 'API开放平台', href: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-4 max-w-xs">
              {siteConfig.description}
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-50"></i>
              </a>
            </div>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#" className="hover:text-primary-400 transition-colors">{section.title}</a>
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 91short. All rights reserved. | 京ICP备xxxxxxxx号
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">Cookie设置</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}